export const spacing = {
    sm: '5px',
    md: '10px',
    lg: '15px',
    xl: '25px',
};
